import ClipperPlaceholder from './ClipperPlaceholder.jsx';

export default function NovedadesRemitoCancelado() {
  return (
    <ClipperPlaceholder title="Remito Cancelado" category="Novedades" />
  );
}
